/*
 * @Author: your name
 * @Date: 2020-10-13 14:28:22
 * @LastEditTime: 2021-04-19 19:35:00
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \fp_h5\src\store\modules\devicelog\devicelog.js
 */
import * as D from '../../../utils/dbmodel';

export default {
    namespaced: true,
    state: {
        searchP:{
            keyword:'',// 
            status:'',
            starttime:'',// 
            endtime:'',// 
            shopcode:'',
            telephone:'',
            branchcode:'',
            smstype:'',
            out_id:'',
            templatetext:'',
            needoem:'',
            templatetype:'',
            templatename:'',
            errorcode:'',
            errmsgcn:'',
            signname:'',
            signapplystatus:'',
            templateapplystatus:''
        },
        searchPAnalysis:{
            starttime:'',// 
            endtime:'',// 
        },

        list: [], //table中的list显示数据
        pagination: {
            
        }, //分页相关的信息
        record: {
            devicekeyword:''
        },//
    },

    getters: {
        getDomainnameSelectOptions(state) {
            return state.domainnameSelectOptions
        }
    },

    mutations: {
        save(state, action) {
            for (var key in action.payload) {
                state[key] = action.payload[key]
            }
        }
    },

    actions: {
        //  列表
        list(context, payload) {
            return D.select({
                ...payload
            })

        },
         
        smsDetailUrl(context, payload){
            return D.select({
                ...payload
            })
        },

        // 短信短信状态  
        updateSmsStatus(context, payload){
            return D.select({
                ...payload
            })
        },

        // 短信重发   
        resendmsg(context, payload){
            return D.select({
                ...payload
            })
        },
                   
                
        querySendNumbersAnalysis(context, payload){
            return D.select({
                ...payload
            })
        },
        querySendNumbersAnalysisFailNumber(context, payload){
            return D.select({
                ...payload
            })
        },

        querySendNumbersAnalysisByDate(context, payload){
            return D.select({
                ...payload
            })
        },
        querySendFailedNumbersAnalysis(context, payload){
            return D.select({
                ...payload
            })
        },
        //详情
        details(context, payload) {
            payload.apikey = 'alarmmanager/details'
            return D.detail({
                ...payload
            }).then(response => {
                const { data } = response.data;
                context.commit({
                    type: 'save',
                    payload: {
                        record: data
                    }
                })
                return response
            })

        },
        // 插叙签名名称下拉列表
        querySmsSignnameList(context, payload){
            return D.select({
                ...payload
            })
        },
        
        querySignPageList(context, payload){
            return D.select({
                ...payload
            })
        },

        addSign(context, payload){
            return D.select({
                ...payload
            })
        },

        deleteSign(context, payload){
            return D.del({
                ...payload
            })
        },
        
        editSign(context, payload){
            return D.select({
                ...payload
            })
        },

        //详情
        detailSign(context, payload) {
            payload.apikey = 'smsmanager/detailsSign'
            return D.detail({
                ...payload
            }).then(response => {
                const { data } = response.data;
                context.commit({
                    type: 'save',
                    payload: {
                        record: data
                    }
                })
                return response
            })

        },

        getEmptySign(context){
            context.commit({
                type: 'save',
                payload: {
                    record: {}
                }
            })
        },
            

        // 短信模版 列表    
        queryTemplatePageList(context, payload){
            return D.select({
                ...payload
            })
        },
        // 短信模版 新增    
        addTemplate(context, payload){
            return D.select({
                ...payload
            })
        },
        // 短信模版 删除    
        deleteTemplate(context, payload){
            return D.del({
                ...payload
            })
        },
        // 短信模版 修改    
        editTemplate(context, payload){
            return D.select({
                ...payload
            })
        },

        //短信模版详情
        detailTemplate(context, payload) {
            payload.apikey = 'smsmanager/detailTemplate'
            return D.detail({
                ...payload
            }).then(response => {
                const { data } = response.data;
                context.commit({
                    type: 'save',
                    payload: {
                        record: data
                    }
                })
                return response
            })

        },
        // 短信模版  清空     
        getEmptyTemplate(context){
            context.commit({
                type: 'save',
                payload: {
                    record: {}
                }
            })
        },

        // 短信模版申请 列表    
        queryTemplateApplyPageList(context, payload){
            return D.select({
                ...payload
            })
        },

        //短信模版申请详情
        detailTemplateApply(context, payload) {
            payload.apikey = 'smsmanager/detailTemplateApply'
            return D.detail({
                ...payload
            }).then(response => {
                const { data } = response.data;
                context.commit({
                    type: 'save',
                    payload: {
                        record: data
                    }
                })
                return response
            })
        },
              
        // 短信模版申请状态刷新  
        queryTemplatteApplyStatus(context, payload){
            return D.select({
                ...payload
            })
        },
                
        // 短信签名申请 列表    
        querySignApplyPageList(context, payload){
            return D.select({
                ...payload
            })
        },

        //短信签名申请详情
        detailSignApply(context, payload) {
            payload.apikey = 'smsmanager/detailTemplateApply'
            return D.detail({
                ...payload
            }).then(response => {
                const { data } = response.data;
                context.commit({
                    type: 'save',
                    payload: {
                        record: data
                    }
                })
                return response
            })

        },
        
        // 短信签名申请状态刷新  
        querySignApplyStatus(context, payload){
            return D.select({
                ...payload
            })
        },
                
        //清空设备管理搜索条件
        getEmptySearch(context){
            context.commit({
                type: 'save',
                payload: {
                    searchP: {
                        keyword:'',// 
                        status:'',
                        starttime:'',// 
                        endtime:'',// 
                        shopcode:'',
                        telephone:'',
                        branchcode:'',
                        smstype:'',
                        out_id:'',
                        templatetext:'',
                        errorcode:'',
                        errmsgcn:'',
                        templatetype:'',
                        signname:'',
                        signapplystatus:'',
                        templateapplystatus:''
                    }
                }
            })
        },  

        //清空设备管理搜索条件
        getEmptySearchAnalysis(context){
            context.commit({
                type: 'save',
                payload: {
                    searchPAnalysis: {
                        starttime:'',// 
                        endtime:'',// 
                    }
                }
            })
        },  
    }
    
}